/**
 * FormsSpamProtect Class
 */
class FormsSpamProtect {

	/**
	 * Constructor
	 *
	 * @return {void}
	 */
	constructor() {

		this.init();

		if ( this.antiSpamInput.length ) {

			document.body.addEventListener( 'mousemove', ( e ) => {

				this.validateActivityMouseMove( e );

			}, false );

		}

		this.forms.forEach( ( form ) => {

			form.addEventListener( 'submit', ( e ) => {

				this.validateActivityTime( e );

			}, false );

		} );

	}

	/**
	 * Initializes components
	 */
	init() {

		this.forms = document.querySelectorAll( 'form' );
		this.antiSpamInput = document.querySelectorAll( '[name=antiSpamProtect]' );
		this.lastPosition = null;
		this.totalDistanceTraveled = 0;
		this.loadedTime = new Date().getTime();

	}

	/**
	 * Validates user activity by tracking the distance the mouse has moved and updates the value of the anti-spam input fields.
	 *
	 * @param {MouseEvent} e The mousemove event object.
	 */
	validateActivityMouseMove( e ) {

		if ( this.lastPosition !== null ) {

			const dx = e.clientX - this.lastPosition.x;
			const dy = e.clientY - this.lastPosition.y;
			this.totalDistanceTraveled += Math.sqrt( ( dx * dx ) + ( dy * dy ) );

		}

		this.lastPosition = { x: e.clientX, y: e.clientY };
		this.antiSpamInput.forEach( ( input ) => {

			input.value = Math.floor( this.totalDistanceTraveled );

		}, false );

	}

	/**
	 * Validates form submission time and updates the hidden anti-spam input field with current and load times.
	 *
	 * @param {Event} e The submit event object.
	 */
	validateActivityTime( e ) {

		const form = e.target;

		const currentTime = new Date().getTime();

		const antiSpamInput2 = form.querySelector( '[name="antiSpamProtect2"]' );
		if ( antiSpamInput2 ) {

			antiSpamInput2.value = `${ this.loadedTime },${ currentTime }`;

		}

	}

}

new FormsSpamProtect;
